import React from 'react';
import PropTypes from 'prop-types';
import { filterWidgetsText } from '../actions';
import { connect } from 'react-redux';
import TextField from 'material-ui/TextField';

function TextFilterInput({ widgets, filterWidgetsText }) {
    return (
        <TextField
            fullWidth
            hintText="Filter by widget"
            onChange={(e, newValue) => filterWidgetsText(newValue, widgets)}
        />
    );
}

TextFilterInput.propTypes = {
    // From connect
    widgets: PropTypes.object.isRequired,
    filterWidgetsText: PropTypes.func.isRequired
};

export default connect(
    ({
        requery = {
            entities: {}
        }
    }) => ({
        widgets: requery.entities.widgets
    }),
    { filterWidgetsText }
)(TextFilterInput);



/** WEBPACK FOOTER **
 ** ../src/dash/front/packs/components/TextFilterInput.js
 **/